import React, { useEffect, useState } from 'react';
import './Pregisterprint.css';
import axios from 'axios';
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import Logo from "../../imgs/dairylogo.png";
import { lightGreen, red } from '@material-ui/core/colors';
import { TaskAltSharp } from '@mui/icons-material';
import { useTranslation } from "react-i18next";

// Register the font using the imported variable
Font.register({
  family: 'Lato-Italic',
  src: LatoItalicFont,
});
Font.register({
  family: "Kannada",
  src: NotoSansKannada,
});
// ... (other imports and Font registration)

const Pregisterprint = (props) => {
  const { t, i18n } = useTranslation();
  const fontBase = i18n.language === "kn" ? "Kannada" : "Lato-Italic";
  const [customerData, setCustomerData] = useState({});
  const [literTotal, setLiterTotal] = useState(0);
  const [amtTotal, setAmtTotal] = useState(0);
  let totals = {};


  const calculateSumOfAmtColumns = (tableDataArray) => {
    const sums = Array.from({ length: 10 }, () => 0); // Initialize an array with 10 zeros

    // Loop through the four tables and calculate sums for each record
    for (let tableIndex = 0; tableIndex < 4; tableIndex++) {
      const tableDataWithZeros = tableDataArray[tableIndex];

      tableDataWithZeros.forEach((entry, entryIndex) => {
        sums[entryIndex] += parseFloat(entry.amt);
      });
    }

    return sums;
  };

  useEffect(() => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    let rawData = {
      date1: localStorage.getItem("date1print"),
      date2: localStorage.getItem("date2print"),
      mainuser: localStorage.getItem("contact"),
      zero: localStorage.getItem("zero"),
      mobileuser: localStorage.getItem("mobileuser"),
      mainuser2: mainuser2,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post('https://excellentdairy.com/dairy/php/cust/getpregister3.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      // console.log(response.data);
      setCustomerData(response.data);
    }).catch(err => {
      console.log(err);
    });
  }, []);

  // Function to generate a date range between date1 and date2
  const getDatesInRange = (date1, date2) => {
    const dates = [];
    const currentDate = new Date(date1);

    while (currentDate <= new Date(date2)) {
      dates.push(currentDate.toISOString().split('T')[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };

  // Function to get all unique 'type' and 'time' combinations
  const getUniqueTypeTimeCombinations = () => {
    const combinations = [];

    Object.keys(customerData).forEach(kno => {
      customerData[kno].forEach(entry => {
        const combination = `${entry.type}-${entry.time}`;
        if (!combinations.includes(combination)) {
          combinations.push(combination);
        }
      });
    });

    return combinations;
  };

  const getFirstAndLastWord = (text) => {
    // Trim any leading or trailing spaces
    let words = "";
    if (text) {
      words = text.trim().split(/\s+/); // Split by one or more whitespace characters
    }
    // Check if there are words present
    if (words.length === 0) {
      return ''; // Return an empty string if no words are present
    } else if (words.length === 1) {
      return words[0]; // Return the single word if only one is present
    } else {
      return `${words[0]} ${words[words.length - 1]}`; // Return first and last word
    }
  };

  const safeText = (v) =>
    String(v ?? "")
      .normalize("NFC")
      // remove zero-width chars (ZWSP, ZWNJ, ZWJ, BOM)
      .replace(/[\u200B\u200C\u200D\uFEFF]/g, "")
      // remove other control chars
      .replace(/[\u0000-\u001F\u007F]/g, "")
      .replace(/\u00A0/g, " ") // nbsp -> space
      .trim();


  const getTableDataWithZeros = (tableData, date1, date2, type, time) => {
    if (!Array.isArray(tableData)) {
      return Array.from({ length: getDatesInRange(date1, date2).length }, (_, index) => ({
        sr: '',
        date: getDatesInRange(date1, date2)[index],
        time: time,
        kno: '',
        type: type,
        liter: '0',
        fat: '0',
        snf: '0',
        rate: '0',
        amt: '0.00',
        date1: date1,
        date2: date2,
        kendra: '',
      }));
    }

    const dateRange = getDatesInRange(date1, date2);
    const tableWithData = [];

    dateRange.forEach(date => {
      const matchingEntry = tableData.find(
        entry => entry.date === date && entry.type === type && entry.time === time
      );

      if (matchingEntry) {
        tableWithData.push(matchingEntry);
      } else {
        // Create a record with zero values
        tableWithData.push({
          sr: '',
          date: date,
          time: time,
          kno: '',
          type: type,
          liter: '0',
          fat: '0',
          snf: '0',
          rate: '0',
          amt: '0.00',
          date1: date1,
          date2: date2,
          kendra: '',
        });
      }
    });

    return tableWithData;
  };

  function formatDate(inputDate) {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(inputDate).toLocaleDateString('en-US', options);
  }

  if (localStorage.getItem('pregister1') === "1") {
    if (Array.isArray(customerData) && customerData.length > 0) {
      totals = {
        tmhliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.mhliter), 0),
        tgayliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.gayliter), 0),
        tliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.tliter), 0),
        billamt: customerData.reduce((total, rowData) => total + parseFloat(rowData.billamt), 0),
        magilthev: customerData.reduce((total, rowData) => total + parseFloat(rowData.magilthev), 0),
        cthev: customerData.reduce((total, rowData) => total + parseFloat(rowData.cthev), 0),
        newthev: customerData.reduce((total, rowData) => total + parseFloat(rowData.newthev), 0),
        madv: customerData.reduce((total, rowData) => total + parseFloat(rowData.madv), 0),
        cadv: customerData.reduce((total, rowData) => total + parseFloat(rowData.cadv), 0),
        tadv: customerData.reduce((total, rowData) => total + parseFloat(rowData.tadv), 0),
        advkapat: customerData.reduce((total, rowData) => total + parseFloat(rowData.advkapat), 0),
        newadv: customerData.reduce((total, rowData) => total + parseFloat(rowData.newadv), 0),
        mkhadya: customerData.reduce((total, rowData) => total + parseFloat(rowData.mkhadya), 0),
        ckhadya: customerData.reduce((total, rowData) => total + parseFloat(rowData.ckhadya), 0),
        tkhadya: customerData.reduce((total, rowData) => total + parseFloat(rowData.tkhadya), 0),
        khadyakapat: customerData.reduce((total, rowData) => total + parseFloat(rowData.khadyakapat), 0),
        newkhadya: customerData.reduce((total, rowData) => total + parseFloat(rowData.newkhadya), 0),
        ikapatliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.ikapatliter), 0),
        ikapatbill: customerData.reduce((total, rowData) => total + parseFloat(rowData.ikapatbill), 0),
        vah: customerData.reduce((total, rowData) => total + parseFloat(rowData.vah), 0),
        ada: customerData.reduce((total, rowData) => {
          if (parseFloat(rowData.ada) > 0) {
            total += parseFloat(rowData.ada);
          }
          return total;
        }, 0)
      };
    }
  }
  else if (localStorage.getItem('pregister1') === "6") {
    if (Array.isArray(customerData) && customerData.length > 0) {
      totals = {
        tmhliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.mhliter), 0),
        tgayliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.gayliter), 0),
        tliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.tliter), 0),
        tcomm: customerData.reduce((total, rowData) => total + parseFloat(rowData.comm), 0),
        billamt: customerData.reduce((total, rowData) => total + parseFloat(rowData.billamt), 0),
        magilthev: customerData.reduce((total, rowData) => total + parseFloat(rowData.magilthev), 0),
        cthev: customerData.reduce((total, rowData) => total + parseFloat(rowData.cthev), 0),
        newthev: customerData.reduce((total, rowData) => total + parseFloat(rowData.newthev), 0),
        madv: customerData.reduce((total, rowData) => total + parseFloat(rowData.madv), 0),
        cadv: customerData.reduce((total, rowData) => total + parseFloat(rowData.cadv), 0),
        tadv: customerData.reduce((total, rowData) => total + parseFloat(rowData.tadv), 0),
        advkapat: customerData.reduce((total, rowData) => total + parseFloat(rowData.advkapat), 0),
        newadv: customerData.reduce((total, rowData) => total + parseFloat(rowData.newadv), 0),
        mkhadya: customerData.reduce((total, rowData) => total + parseFloat(rowData.mkhadya), 0),
        ckhadya: customerData.reduce((total, rowData) => total + parseFloat(rowData.ckhadya), 0),
        tkhadya: customerData.reduce((total, rowData) => total + parseFloat(rowData.tkhadya), 0),
        khadyakapat: customerData.reduce((total, rowData) => total + parseFloat(rowData.khadyakapat), 0),
        newkhadya: customerData.reduce((total, rowData) => total + parseFloat(rowData.newkhadya), 0),
        ikapatliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.ikapatliter), 0),
        ikapatbill: customerData.reduce((total, rowData) => total + parseFloat(rowData.ikapatbill), 0),
        vah: customerData.reduce((total, rowData) => total + parseFloat(rowData.vah), 0),
        ada: customerData.reduce((total, rowData) => {
          if (parseFloat(rowData.ada) > 0) {
            total += parseFloat(rowData.ada);
          }
          return total;
        }, 0)
      };
    }
  }
  else {
    if (Array.isArray(customerData) && customerData.length > 0) {
      totals = {
        gayliter: customerData.reduce((total, rowData) => parseFloat(rowData.tgayliter), 0),
        gayamt: customerData.reduce((total, rowData) => parseFloat(rowData.tgayamt), 0),
        mhliter: customerData.reduce((total, rowData) => parseFloat(rowData.tmhliter), 0),
        mhamt: customerData.reduce((total, rowData) => parseFloat(rowData.tmhamt), 0),
        mhmorliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.mhmorliter), 0),
        mhevnliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.mhevnliter), 0),
        gaymorliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.gaymorliter), 0),
        gayevnliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.gayevnliter), 0),
        mhmoramt: customerData.reduce((total, rowData) => total + parseFloat(rowData.mhmoramt), 0),
        mhevnamt: customerData.reduce((total, rowData) => total + parseFloat(rowData.mhevnamt), 0),
        gaymoramt: customerData.reduce((total, rowData) => total + parseFloat(rowData.gaymoramt), 0),
        gayevnamt: customerData.reduce((total, rowData) => total + parseFloat(rowData.gayevnamt), 0),
        cthevitr1: customerData.reduce((total, rowData) => total + parseFloat(rowData.cthevitr1), 0),
        cthevitr2: customerData.reduce((total, rowData) => total + parseFloat(rowData.cthevitr2), 0),
        cthevitr3: customerData.reduce((total, rowData) => total + parseFloat(rowData.cthevitr3), 0),
        advkapat: customerData.reduce((total, rowData) => total + parseFloat(rowData.advkapat), 0),
        khadyakapat: customerData.reduce((total, rowData) => total + parseFloat(rowData.khadyakapat), 0),
        ratibkapat: customerData.reduce((total, rowData) => total + parseFloat(rowData.ratibkapat), 0),
        sanghkapat: customerData.reduce((total, rowData) => total + parseFloat(rowData.sanghkapat), 0),
        retan: customerData.reduce((total, rowData) => total + parseFloat(rowData.retan), 0),
        medi: customerData.reduce((total, rowData) => total + parseFloat(rowData.medi), 0),
        karjhpta: customerData.reduce((total, rowData) => total + parseFloat(rowData.karjhpta), 0),
        karjintr: customerData.reduce((total, rowData) => total + parseFloat(rowData.karjintr), 0),
        cbhishi: customerData.reduce((total, rowData) => total + parseFloat(rowData.cbhishi), 0),
        ikapatbill: customerData.reduce((total, rowData) => total + parseFloat(rowData.ikapatbill), 0),
        itrkapat1: customerData.reduce((total, rowData) => total + parseFloat(rowData.itrkapat1), 0),
        itrkapat2: customerData.reduce((total, rowData) => total + parseFloat(rowData.itrkapat2), 0),
        itrkapat3: customerData.reduce((total, rowData) => total + parseFloat(rowData.itrkapat3), 0),
        tliter: customerData.reduce((total, rowData) => parseFloat(rowData.ttliter), 0),
        tamt: customerData.reduce((total, rowData) => parseFloat(rowData.tbillamt), 0),
        cthev: customerData.reduce((total, rowData) => total + parseFloat(rowData.cthev), 0),
        ckhadya: customerData.reduce((total, rowData) => total + parseFloat(rowData.ckhadya), 0),
        cadv: customerData.reduce((total, rowData) => total + parseFloat(rowData.cadv), 0),
        khadyakapat: customerData.reduce((total, rowData) => total + parseFloat(rowData.khadyakapat), 0),
        advkapat: customerData.reduce((total, rowData) => total + parseFloat(rowData.advkapat), 0),
        newkhadya: customerData.reduce((total, rowData) => total + parseFloat(rowData.newkhadya), 0),
        newadv: customerData.reduce((total, rowData) => total + parseFloat(rowData.newadv), 0),
        ada: customerData.reduce((total, rowData) => total + parseFloat(rowData.ada), 0),

      };
    }
  }


  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      // Make sure that the input is a string
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        // Create block
        var a = str.charCodeAt(i);
        // Bitwise XOR
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  const recordsPerPage = 21;
  const recordsPerPage2 = 30;
  const recordsPerPage4 = 13;
  const recordsPerPage5 = 10;
  const recordsPerPagever = 35;
  const totalPages = Math.ceil(customerData.length / recordsPerPage);
  const totalPages2 = Math.ceil(customerData.length / recordsPerPagever);
  const totalPages4 = Math.ceil(customerData.length / recordsPerPage4);
  const totalPages5 = Math.ceil(customerData.length / recordsPerPage5);
  const styles = getStyles(fontBase);
  return (
    <>
      {
        localStorage.getItem('pregister1') === "1"
          ?
          <PDFViewer className='pdf'>
            <Document>
              {customerData.length > 0 && (
                Array.from({ length: Math.ceil(customerData.length / recordsPerPage) }).map((_, pageIndex) => (
                  <Page
                    size="A4"
                    orientation="landscape"
                    style={{ marginTop: 20, marginLeft: 5, marginRight: 5 }}
                    key={pageIndex}
                  >
                    <Text style={styles.latoText}>{safeText(customerData?.[0]?.kendra)}</Text>

                    <Text style={styles.latoText2}>
                      {t("pregisterprint.periodLine", {
                        from: formatDate(localStorage.getItem("date1print")),
                        to: formatDate(localStorage.getItem("date2print"))
                      })}
                    </Text>

                    <View style={styles.table}>
                      {/* Table Header */}
                      <View style={styles.tableRow2}>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.accountNo")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.name")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.buffaloLiter")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.cowLiter")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.totalLiter")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.totalBill")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.prevDepositShort")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.depositShort")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.totalDepositShort")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.prevAdvanceBalance")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.advanceOn")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.totalAdvanceShort")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.advanceDeduct")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.newAdvanceBalance")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.prevKhadyBalance")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.khadyOn")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.totalKhadyShort")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.khadyDeduct")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.newKhadyBalance")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.otherDeductPerLiter")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.otherDeductPerBill")}</Text>
                        <Text style={styles.tableHeader}>{t("pregisterprint.table.transport")}</Text>
                        <Text style={styles.tableHeaderlast}>{t("pregisterprint.table.netPayable")}</Text>
                      </View>

                      {customerData
                        .slice(pageIndex * recordsPerPage, (pageIndex + 1) * recordsPerPage)
                        .map((rowData, index) => (
                          <View key={index} style={styles.tableRow}>
                            <Text style={styles.tableCell}>{rowData.kno}</Text>
                            <Text style={styles.tableCell}>{safeText(getFirstAndLastWord(rowData.cname))}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.mhliter).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.gayliter).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.tliter).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.billamt).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.magilthev).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.cthev).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.newthev).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.madv).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.cadv).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.tadv).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.advkapat).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.newadv).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.mkhadya).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.ckhadya).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.tkhadya).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.khadyakapat).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.newkhadya).toFixed(2)}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.ikapatliter) ? parseFloat(rowData.ikapatliter) : 0}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.ikapatbill) ? parseFloat(rowData.ikapatbill) : 0}</Text>
                            <Text style={styles.tableCell}>{parseFloat(rowData.vah) ? parseFloat(rowData.vah) : 0}</Text>
                            <Text style={styles.tableCell}>
                              {parseFloat(rowData.ada)
                                ? parseFloat(rowData.ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)
                                : 0}
                            </Text>
                          </View>
                        ))}
                    </View>

                    {pageIndex === totalPages - 1 && (
                      <View style={styles.table}>
                        <View style={styles.tableRow3}>
                          <Text style={styles.tableHeader}>{t("pregisterprint.totalRow.total")}</Text>
                          <Text style={styles.tableHeader}>{t("pregisterprint.totalRow.dash")}</Text>

                          <Text style={styles.tableHeader}>{parseFloat(totals.tmhliter).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.tgayliter).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.tliter).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.billamt).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.magilthev).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.cthev).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.newthev).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.madv).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.cadv).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.tadv).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.advkapat).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.newadv).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.mkhadya).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.ckhadya).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.tkhadya).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.khadyakapat).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.newkhadya).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.ikapatliter).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.ikapatbill).toFixed(2)}</Text>
                          <Text style={styles.tableHeader}>{parseFloat(totals.vah).toFixed(2)}</Text>
                          <Text style={styles.tableHeaderlast}>
                            {parseFloat(totals.ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)}
                          </Text>
                        </View>
                      </View>
                    )}
                  </Page>

                ))
              )}
            </Document>
          </PDFViewer >
          : localStorage.getItem('pregister1') === "2" ?
            <PDFViewer className='pdf'>
              <Document>
                {customerData.length > 0 && (
                  Array.from({ length: Math.ceil(customerData.length / recordsPerPagever) }).map((_, pageIndex) => (
                    <Page size="A4" style={{ marginTop: 20, marginLeft: 5, marginRight: 5 }} key={pageIndex}>
                      <Text style={styles.latoText}>{safeText(customerData?.[0]?.kendra)}</Text>

                      <Text style={styles.latoText2}>
                        {t("pregisterprint2.periodLine", {
                          from: formatDate(localStorage.getItem("date1print")),
                          to: formatDate(localStorage.getItem("date2print"))
                        })}
                      </Text>

                      <View style={styles.table}>
                        {/* Table Header */}
                        <View style={styles.tableRow2}>
                          <Text style={styles.tableHeadersmall}>{t("pregisterprint2.table.sr")}</Text>
                          <Text style={styles.tableHeadersmallmed}>{t("pregisterprint2.table.account")}</Text>
                          <Text style={styles.tableHeader}>{t("pregisterprint2.table.name")}</Text>
                          <Text style={styles.tableHeader}>{t("pregisterprint2.table.totalLiter")}</Text>
                          <Text style={styles.tableHeader}>{t("pregisterprint2.table.totalAmount")}</Text>
                          <Text style={styles.tableHeader}>{t("pregisterprint2.table.onDeposit")}</Text>
                          <Text style={styles.tableHeader}>{t("pregisterprint2.table.onAdvance")}</Text>
                          <Text style={styles.tableHeader}>{t("pregisterprint2.table.advanceBalance")}</Text>
                          <Text style={styles.tableHeader}>{t("pregisterprint2.table.onKhady")}</Text>
                          <Text style={styles.tableHeader}>{t("pregisterprint2.table.khadyBalance")}</Text>
                          <Text style={styles.tableHeader}>{t("pregisterprint2.table.netPayable")}</Text>
                          <Text style={styles.tableHeader}>{t("pregisterprint2.table.sign")}</Text>
                        </View>

                        {customerData
                          .slice(pageIndex * recordsPerPagever, (pageIndex + 1) * recordsPerPagever)
                          .map((rowData, index) => (
                            <View key={index} style={styles.tableRow}>
                              <Text style={styles.tableCellsmall2}>{pageIndex * recordsPerPagever + index + 1}</Text>
                              <Text style={styles.tableCellsmall2med}>{rowData.kno}</Text>
                              <Text style={styles.tableCell}>{safeText(getFirstAndLastWord(rowData.cname))}</Text>
                              <Text style={styles.tableCell2}>{parseFloat(rowData.tliter).toFixed(2)}</Text>
                              <Text style={styles.tableCell2}>{parseFloat(rowData.billamt).toFixed(2)}</Text>
                              <Text style={styles.tableCell2}>{parseFloat(rowData.cthev).toFixed(2)}</Text>
                              <Text style={styles.tableCell2}>{parseFloat(rowData.cadv).toFixed(2)}</Text>
                              <Text style={styles.tableCell2}>{parseFloat(rowData.newadv).toFixed(2)}</Text>
                              <Text style={styles.tableCell2}>{parseFloat(rowData.ckhadya).toFixed(2)}</Text>
                              <Text style={styles.tableCell2}>{parseFloat(rowData.newkhadya).toFixed(2)}</Text>
                              <Text style={styles.tableCell2}>
                                {parseFloat(rowData.ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)}
                              </Text>
                              <Text style={styles.tableCell2}>{""}</Text>
                            </View>
                          ))}
                      </View>

                      {pageIndex === totalPages2 - 1 && (
                        <View style={styles.bottomrow}>

                          <View style={styles.box1}>
                            <View style={styles.bottomtitlerow}>
                              <View style={{ flex: 1, justifyContent: 'center' }}>
                                <Text style={[styles.valueText, { lineHeight: 18 }]}>
                                  {t("pregisterprint2.bottom.totalCowLiter")}
                                </Text>
                              </View>
                              <View style={{ flex: 1, justifyContent: 'center' }}>
                                <Text style={[styles.valueText, { textAlign: 'right', lineHeight: 18 }]}>
                                  {parseFloat(totals.gayliter).toFixed(2)}
                                </Text>
                              </View>
                            </View>

                            <View style={styles.bottomtitlerow}>
                              <View style={{ flex: 1 }}>
                                <Text style={styles.valueText}>{t("pregisterprint2.bottom.totalBuffaloLiter")}</Text>
                              </View>
                              <View style={{ flex: 1 }}>
                                <Text style={[styles.valueText, { textAlign: 'right' }]}>
                                  {parseFloat(totals.mhliter).toFixed(2)}
                                </Text>
                              </View>
                            </View>

                            <View style={styles.bottomtitlerow}>
                              <View style={{ flex: 1 }}>
                                <Text style={styles.valueText}>{t("pregisterprint2.bottom.totalLiter")}</Text>
                              </View>
                              <View style={{ flex: 1 }}>
                                <Text style={[styles.valueText, { textAlign: 'right' }]}>
                                  {parseFloat(totals.tliter).toFixed(2)}
                                </Text>
                              </View>
                            </View>
                          </View>

                          <View style={styles.box2}>
                            <View style={styles.bottomtitlerow3}>
                              <View style={{ flex: 1, justifyContent: 'center' }}>
                                <Text style={[styles.valueText, { lineHeight: 18 }]}>
                                  {t("pregisterprint2.bottom.totalCowAmount")}
                                </Text>
                              </View>
                              <View style={{ flex: 1, justifyContent: 'center' }}>
                                <Text style={[styles.valueText, { textAlign: 'right', lineHeight: 18 }]}>
                                  {parseFloat(totals.gayamt).toFixed(2)}
                                </Text>
                              </View>
                            </View>

                            <View style={styles.bottomtitlerow3}>
                              <View style={{ flex: 1 }}>
                                <Text style={styles.valueText}>{t("pregisterprint2.bottom.totalBuffaloAmount")}</Text>
                              </View>
                              <View style={{ flex: 1 }}>
                                <Text style={[styles.valueText, { textAlign: 'right' }]}>
                                  {parseFloat(totals.mhamt).toFixed(2)}
                                </Text>
                              </View>
                            </View>

                            <View style={styles.bottomtitlerow3}>
                              <View style={{ flex: 1 }}>
                                <Text style={styles.valueText}>{t("pregisterprint2.bottom.totalAmount")}</Text>
                              </View>
                              <View style={{ flex: 1 }}>
                                <Text style={[styles.valueText, { textAlign: 'right' }]}>
                                  {parseFloat(totals.tamt).toFixed(2)}
                                </Text>
                              </View>
                            </View>
                          </View>

                          <View style={styles.box2}>
                            <View style={styles.bottomtitlerow3}>
                              <View style={{ flex: 1, justifyContent: 'center' }}>
                                <Text style={[styles.valueText, { lineHeight: 18 }]}>
                                  {t("pregisterprint2.bottom.totalCurrentDeposit")}
                                </Text>
                              </View>
                              <View style={{ flex: 1, justifyContent: 'center' }}>
                                <Text style={[styles.valueText, { textAlign: 'right', lineHeight: 18 }]}>
                                  {parseFloat(totals.cthev).toFixed(2)}
                                </Text>
                              </View>
                            </View>

                            <View style={styles.bottomtitlerow3}>
                              <View style={{ flex: 1 }}>
                                <Text style={styles.valueText}>{t("pregisterprint2.bottom.totalKhady")}</Text>
                              </View>
                              <View style={{ flex: 1 }}>
                                <Text style={[styles.valueText, { textAlign: 'right' }]}>
                                  {parseFloat(totals.ckhadya).toFixed(2)}
                                </Text>
                              </View>
                            </View>

                            <View style={styles.bottomtitlerow3}>
                              <View style={{ flex: 1 }}>
                                <Text style={styles.valueText}>{t("pregisterprint2.bottom.totalAdvance")}</Text>
                              </View>
                              <View style={{ flex: 1 }}>
                                <Text style={[styles.valueText, { textAlign: 'right' }]}>
                                  {parseFloat(totals.cadv).toFixed(2)}
                                </Text>
                              </View>
                            </View>
                          </View>

                          <View style={styles.box2}>
                            <View style={styles.bottomtitlerow3}>
                              <View style={{ flex: 1, justifyContent: 'center' }}>
                                <Text style={[styles.valueText, { lineHeight: 18 }]}>
                                  {t("pregisterprint2.bottom.khadyDeduct")}
                                </Text>
                              </View>
                              <View style={{ flex: 1, justifyContent: 'center' }}>
                                <Text style={[styles.valueText, { textAlign: 'right', lineHeight: 18 }]}>
                                  {parseFloat(totals.khadyakapat).toFixed(2)}
                                </Text>
                              </View>
                            </View>

                            <View style={styles.bottomtitlerow3}>
                              <View style={{ flex: 1 }}>
                                <Text style={styles.valueText}>{t("pregisterprint2.bottom.advanceDeduct")}</Text>
                              </View>
                              <View style={{ flex: 1 }}>
                                <Text style={[styles.valueText, { textAlign: 'right' }]}>
                                  {parseFloat(totals.advkapat).toFixed(2)}
                                </Text>
                              </View>
                            </View>

                            <View style={styles.bottomtitlerow3}>
                              <View style={{ flex: 1 }}>
                                <Text style={styles.valueText}>{t("pregisterprint2.bottom.totalDueBalance")}</Text>
                              </View>
                              <View style={{ flex: 1 }}>
                                <Text style={[styles.valueText, { textAlign: 'right' }]}>
                                  {parseFloat(totals.newadv + totals.newkhadya).toFixed(2)}
                                </Text>
                              </View>
                            </View>

                            <View style={styles.bottomtitlerow3}>
                              <View style={{ flex: 1 }}>
                                <Text style={styles.valueText}>{t("pregisterprint2.bottom.totalPaidAmount")}</Text>
                              </View>
                              <View style={{ flex: 1 }}>
                                <Text style={[styles.valueTextbig, { textAlign: 'right' }]}>
                                  {parseFloat(totals.ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)}
                                </Text>
                              </View>
                            </View>
                          </View>

                        </View>
                      )}
                    </Page>
                  ))
                )}
              </Document>
            </PDFViewer>

            : localStorage.getItem('pregister1') === "3" ?

              <PDFViewer className='pdf'>
                <Document>
                  {customerData.length > 0 && (
                    Array.from({ length: Math.ceil(customerData.length / recordsPerPage4) }).map((_, pageIndex) => (
                      <Page size="A4" style={{ marginTop: 20, marginLeft: 5, marginRight: 5 }} key={pageIndex}>
                        <Text style={styles.latoText}>{safeText(customerData?.[0]?.kendra)}</Text>

                        <Text style={styles.latoText2}>
                          {t("pregisterprint4.periodLine", {
                            from: formatDate(localStorage.getItem("date1print")),
                            to: formatDate(localStorage.getItem("date2print"))
                          })}
                        </Text>

                        <View style={styles.table}>
                          {/* Table Header */}
                          <View style={styles.tableRow2}>
                            <Text style={styles.tableHeadersmall}>{t("pregisterprint4.table.sr")}</Text>
                            <Text style={styles.tableHeadermax}>{t("pregisterprint4.table.account")}</Text>
                            <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.bill")}</Text>
                            <Text style={styles.tableHeaderbig}>{""}</Text>
                            <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.deposit")}</Text>
                            <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.advance")}</Text>
                            <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.khady")}</Text>
                            <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.advancePlusKhady")}</Text>
                            <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.netPayable")}</Text>
                            <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.sign")}</Text>
                          </View>

                          {customerData
                            .slice(pageIndex * recordsPerPage4, (pageIndex + 1) * recordsPerPage4)
                            .map((rowData, index) => (
                              <View key={index} style={styles.tableRow}>
                                <Text style={styles.tableCellsmall}>{pageIndex * recordsPerPage4 + index + 1}</Text>

                                <Text style={styles.tableCellmax}>
                                  {rowData.kno + " : " + safeText(getFirstAndLastWord(rowData.cname))}
                                </Text>

                                <Text style={styles.tableCellbig}>
                                  {t("pregisterprint4.row.billCell", {
                                    liter: parseFloat(rowData.tliter).toFixed(2),
                                    amount: parseFloat(rowData.billamt).toFixed(2)
                                  })}
                                </Text>

                                <Text style={styles.tableCellright}>
                                  {t("pregisterprint4.row.rightLabels")}
                                </Text>

                                <Text style={styles.tableCellbig}>
                                  {t("pregisterprint4.row.depositCell", {
                                    total: parseFloat(rowData.magilthev).toFixed(2),
                                    deduct: parseFloat(rowData.cthev).toFixed(2),
                                    balance: parseFloat(rowData.newthev).toFixed(2)
                                  })}
                                </Text>

                                <Text style={styles.tableCellbig}>{""}</Text>
                                <Text style={styles.tableCellbig}>{""}</Text>
                                <Text style={styles.tableCellbig}>{""}</Text>
                                <Text style={styles.tableCellbig}>{""}</Text>
                                <Text style={styles.tableCellbig}>{""}</Text>
                              </View>
                            ))}
                        </View>
                      </Page>
                    ))
                  )}
                </Document>
              </PDFViewer>

              : localStorage.getItem('pregister1') === "4" ?
                <PDFViewer className='pdf'>
                  <Document>
                    {customerData.length > 0 && (
                      Array.from({ length: Math.ceil(customerData.length / recordsPerPage4) }).map((_, pageIndex) => (
                        <Page size="A4" style={{ marginTop: 20, marginLeft: 5, marginRight: 5 }} key={pageIndex}>
                          <Text style={styles.latoText}>{safeText(customerData?.[0]?.kendra)}</Text>

                          <Text style={styles.latoText2}>
                            {t("pregisterprint4.periodLine", {
                              from: formatDate(localStorage.getItem("date1print")),
                              to: formatDate(localStorage.getItem("date2print"))
                            })}
                          </Text>

                          <View style={styles.table}>
                            {/* Table Header */}
                            <View style={styles.tableRow2}>
                              <Text style={styles.tableHeadersmall}>{t("pregisterprint4.table.sr")}</Text>
                              <Text style={styles.tableHeadermax}>{t("pregisterprint4.table.account")}</Text>
                              <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.bill")}</Text>
                              <Text style={styles.tableHeaderbig}>{""}</Text>
                              <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.deposit")}</Text>
                              <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.advance")}</Text>
                              <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.khady")}</Text>
                              <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.advancePlusKhady")}</Text>
                              <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.netPayable")}</Text>
                              <Text style={styles.tableHeaderbig}>{t("pregisterprint4.table.sign")}</Text>
                            </View>

                            {customerData
                              .slice(pageIndex * recordsPerPage4, (pageIndex + 1) * recordsPerPage4)
                              .map((rowData, index) => (
                                <View key={index} style={styles.tableRow}>
                                  <Text style={styles.tableCellsmall}>{pageIndex * recordsPerPage4 + index + 1}</Text>

                                  <Text style={styles.tableCellmax}>
                                    {rowData.kno + " : " + safeText(getFirstAndLastWord(rowData.cname))}
                                  </Text>

                                  <Text style={styles.tableCellbig}>
                                    {t("pregisterprint4.row.billCell", {
                                      liter: parseFloat(rowData.tliter).toFixed(2),
                                      amount: parseFloat(rowData.billamt).toFixed(2)
                                    })}
                                  </Text>

                                  <Text style={styles.tableCellright}>
                                    {t("pregisterprint4.row.rightLabels")}
                                  </Text>

                                  {/* ठेव */}
                                  <Text style={styles.tableCellbig}>
                                    {t("pregisterprint4.row.thDepositCell", {
                                      total: parseFloat(rowData.magilthev).toFixed(2),
                                      deduct: parseFloat(rowData.cthev).toFixed(2),
                                      balance: parseFloat(rowData.newthev).toFixed(2)
                                    })}
                                  </Text>

                                  {/* एडव्हांस */}
                                  <Text style={styles.tableCellbig}>
                                    {t("pregisterprint4.row.advanceCell", {
                                      total: parseFloat(rowData.tadv).toFixed(2),
                                      deduct: parseFloat(rowData.advkapat).toFixed(2),
                                      balance: parseFloat(rowData.newadv).toFixed(2)
                                    })}
                                  </Text>

                                  {/* खाद्य */}
                                  <Text style={styles.tableCellbig}>
                                    {t("pregisterprint4.row.khadyCell", {
                                      total: parseFloat(rowData.tkhadya).toFixed(2),
                                      deduct: parseFloat(rowData.khadyakapat).toFixed(2),
                                      balance: parseFloat(rowData.newkhadya).toFixed(2)
                                    })}
                                  </Text>

                                  {/* एडव्हांस + खाद्य */}
                                  <Text style={styles.tableCellbig}>
                                    {t("pregisterprint4.row.advancePlusKhadyCell", {
                                      total: parseFloat(parseFloat(rowData.tadv) + parseFloat(rowData.tkhadya)).toFixed(2),
                                      deduct: parseFloat(parseFloat(rowData.advkapat) + parseFloat(rowData.khadyakapat)).toFixed(2),
                                      balance: parseFloat(parseFloat(rowData.newadv) + parseFloat(rowData.newkhadya)).toFixed(2)
                                    })}
                                  </Text>

                                  {/* अदा */}
                                  <Text style={styles.tableCellbig}>
                                    {t("pregisterprint4.row.adaCell", {
                                      amount: parseFloat(rowData.ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)
                                    })}
                                  </Text>

                                  {/* सही */}
                                  <Text style={styles.tableCellbig}>{""}</Text>
                                </View>
                              ))}
                          </View>

                          {pageIndex === totalPages4 - 1 && (
                            <View style={styles.bottomrow} wrap={false}>

                              <View style={styles.box1}>
                                <View style={styles.bottomtitlerow}>
                                  <View style={{ flex: 1, justifyContent: 'center' }}>
                                    <Text style={[styles.valueText, { lineHeight: 18 }]}>{t("pregisterprint4.bottom.totalCowLiter")}</Text>
                                  </View>
                                  <View style={{ flex: 1, justifyContent: 'center' }}>
                                    <Text style={[styles.valueText, { textAlign: 'right', lineHeight: 18 }]}>{parseFloat(totals.gayliter).toFixed(2)}</Text>
                                  </View>
                                </View>

                                <View style={styles.bottomtitlerow}>
                                  <View style={{ flex: 1 }}>
                                    <Text style={styles.valueText}>{t("pregisterprint4.bottom.totalBuffaloLiter")}</Text>
                                  </View>
                                  <View style={{ flex: 1 }}>
                                    <Text style={[styles.valueText, { textAlign: 'right' }]}>{parseFloat(totals.mhliter).toFixed(2)}</Text>
                                  </View>
                                </View>

                                <View style={styles.bottomtitlerow}>
                                  <View style={{ flex: 1 }}>
                                    <Text style={styles.valueText}>{t("pregisterprint4.bottom.totalLiter")}</Text>
                                  </View>
                                  <View style={{ flex: 1 }}>
                                    <Text style={[styles.valueText, { textAlign: 'right' }]}>{parseFloat(totals.tliter).toFixed(2)}</Text>
                                  </View>
                                </View>
                              </View>

                              <View style={styles.box2} wrap={false}>
                                <View style={styles.bottomtitlerow3}>
                                  <View style={{ flex: 1, justifyContent: 'center' }}>
                                    <Text style={[styles.valueText, { lineHeight: 18 }]}>{t("pregisterprint4.bottom.totalCowAmount")}</Text>
                                  </View>
                                  <View style={{ flex: 1, justifyContent: 'center' }}>
                                    <Text style={[styles.valueText, { textAlign: 'right', lineHeight: 18 }]}>{parseFloat(totals.gayamt).toFixed(2)}</Text>
                                  </View>
                                </View>

                                <View style={styles.bottomtitlerow3}>
                                  <View style={{ flex: 1 }}>
                                    <Text style={styles.valueText}>{t("pregisterprint4.bottom.totalBuffaloAmount")}</Text>
                                  </View>
                                  <View style={{ flex: 1 }}>
                                    <Text style={[styles.valueText, { textAlign: 'right' }]}>{parseFloat(totals.mhamt).toFixed(2)}</Text>
                                  </View>
                                </View>

                                <View style={styles.bottomtitlerow3}>
                                  <View style={{ flex: 1 }}>
                                    <Text style={styles.valueText}>{t("pregisterprint4.bottom.totalAmount")}</Text>
                                  </View>
                                  <View style={{ flex: 1 }}>
                                    <Text style={[styles.valueText, { textAlign: 'right' }]}>{parseFloat(totals.tamt).toFixed(2)}</Text>
                                  </View>
                                </View>
                              </View>

                              <View style={styles.box3} wrap={false}>
                                <View style={styles.bottomtitlerow3}>
                                  <View style={{ flex: 1, justifyContent: 'center' }}>
                                    <Text style={[styles.valueText, { lineHeight: 18 }]}>{t("pregisterprint4.bottom.totalOnDeposit")}</Text>
                                  </View>
                                  <View style={{ flex: 1, justifyContent: 'center' }}>
                                    <Text style={[styles.valueText, { textAlign: 'right', lineHeight: 18 }]}>{parseFloat(totals.cthev).toFixed(2)}</Text>
                                  </View>
                                </View>

                                <View style={styles.bottomtitlerow3}>
                                  <View style={{ flex: 1 }}>
                                    <Text style={styles.valueText}>{t("pregisterprint4.bottom.totalKhady")}</Text>
                                  </View>
                                  <View style={{ flex: 1 }}>
                                    <Text style={[styles.valueText, { textAlign: 'right' }]}>{parseFloat(totals.ckhadya).toFixed(2)}</Text>
                                  </View>
                                </View>

                                <View style={styles.bottomtitlerow3}>
                                  <View style={{ flex: 1 }}>
                                    <Text style={styles.valueText}>{t("pregisterprint4.bottom.totalAdvance")}</Text>
                                  </View>
                                  <View style={{ flex: 1 }}>
                                    <Text style={[styles.valueText, { textAlign: 'right' }]}>{parseFloat(totals.cadv).toFixed(2)}</Text>
                                  </View>
                                </View>
                              </View>

                              <View style={styles.box4} wrap={false}>
                                <View style={styles.bottomtitlerow3}>
                                  <View style={{ flex: 1, justifyContent: 'center' }}>
                                    <Text style={[styles.valueText, { lineHeight: 18 }]}>{t("pregisterprint4.bottom.khadyDeduct")}</Text>
                                  </View>
                                  <View style={{ flex: 1, justifyContent: 'center' }}>
                                    <Text style={[styles.valueText, { textAlign: 'right', lineHeight: 18 }]}>{parseFloat(totals.khadyakapat).toFixed(2)}</Text>
                                  </View>
                                </View>

                                <View style={styles.bottomtitlerow3}>
                                  <View style={{ flex: 1 }}>
                                    <Text style={styles.valueText}>{t("pregisterprint4.bottom.advanceDeduct")}</Text>
                                  </View>
                                  <View style={{ flex: 1 }}>
                                    <Text style={[styles.valueText, { textAlign: 'right' }]}>{parseFloat(totals.advkapat).toFixed(2)}</Text>
                                  </View>
                                </View>

                                <View style={styles.bottomtitlerow3}>
                                  <View style={{ flex: 1 }}>
                                    <Text style={styles.valueText}>{t("pregisterprint4.bottom.totalDueBalance")}</Text>
                                  </View>
                                  <View style={{ flex: 1 }}>
                                    <Text style={[styles.valueText, { textAlign: 'right' }]}>{parseFloat(totals.newadv + totals.newkhadya).toFixed(2)}</Text>
                                  </View>
                                </View>

                                <View style={styles.bottomtitlerow3}>
                                  <View style={{ flex: 1 }}>
                                    <Text style={styles.valueText}>{t("pregisterprint4.bottom.totalPaid")}</Text>
                                  </View>
                                  <View style={{ flex: 1 }}>
                                    <Text style={[styles.valueTextbig, { textAlign: 'right' }]}>{parseFloat(totals.ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)}</Text>
                                  </View>
                                </View>
                              </View>

                            </View>
                          )}
                        </Page>
                      ))
                    )}
                  </Document>
                </PDFViewer>

                : localStorage.getItem('pregister1') === "5" ?
                  <PDFViewer className='pdf'>
                    <Document>
                      {customerData.length > 0 && (
                        Array.from({ length: Math.ceil(customerData.length / recordsPerPage5) }).map((_, pageIndex) => (
                          <Page size="A4" style={{ marginTop: 20, marginLeft: 5, marginRight: 5 }} key={pageIndex}>
                            <Text style={styles.latoText}>{safeText(customerData?.[0]?.kendra)}</Text>

                            <Text style={styles.latoText2}>
                              {t("pregisterprint5.periodLine", {
                                from: formatDate(localStorage.getItem("date1print")),
                                to: formatDate(localStorage.getItem("date2print"))
                              })}
                            </Text>

                            <View style={styles.table}>
                              {/* Table Header */}
                              <View style={styles.tableRow2new}>
                                <Text style={styles.tableHeadersmall}>{t("pregisterprint5.table.account")}</Text>
                                <Text style={styles.tableHeaderbigname}>{t("pregisterprint5.table.member")}</Text>
                                <Text style={styles.tableHeaderbig5}>{t("pregisterprint5.table.buffaloMilk")}</Text>
                                <Text style={styles.tableHeaderbig5}>{t("pregisterprint5.table.cowMilk")}</Text>
                                <Text style={styles.tableHeaderbig5}>{t("pregisterprint5.table.totalMilk")}</Text>
                                <Text style={styles.tableHeaderbig5}>{t("pregisterprint5.table.totalAmount")}</Text>
                                <Text style={styles.tableHeaderbig5}>{t("pregisterprint5.table.totalDeduct")}</Text>
                                <Text style={styles.tableHeaderbig5}>{t("pregisterprint5.table.transport")}</Text>
                                <Text style={styles.tableHeaderbig5}>{t("pregisterprint5.table.netPayable")}</Text>
                                <Text style={styles.tableHeaderbiglast}>{t("pregisterprint5.table.sign")}</Text>
                              </View>

                              {customerData
                                .slice(pageIndex * recordsPerPage5, (pageIndex + 1) * recordsPerPage5)
                                .map((rowData, index) => {
                                  const totalDeduct = parseFloat(
                                    parseFloat(rowData.cthev || 0) +
                                    parseFloat(rowData.cthevitr1 || 0) +
                                    parseFloat(rowData.cthevitr2 || 0) +
                                    parseFloat(rowData.cthevitr3 || 0) +
                                    parseFloat(rowData.advkapat || 0) +
                                    parseFloat(rowData.khadyakapat || 0) +
                                    parseFloat(rowData.ratibkapat || 0) +
                                    parseFloat(rowData.sanghkapat || 0) +
                                    parseFloat(rowData.retan || 0) +
                                    parseFloat(rowData.medi || 0) +
                                    parseFloat(rowData.karjhpta || 0) +
                                    parseFloat(rowData.karjintr || 0) +
                                    parseFloat(rowData.cbhishi || 0) +
                                    parseFloat(rowData.ikapatbill || 0) +
                                    parseFloat(rowData.itrkapat1 || 0) +
                                    parseFloat(rowData.itrkapat2 || 0) +
                                    parseFloat(rowData.itrkapat3 || 0)
                                  ).toFixed(2);

                                  return (
                                    <View key={index}>
                                      {/* Main row */}
                                      <View style={styles.tableRowsub}>
                                        <Text style={styles.tableCellsmall5}>{rowData.kno}</Text>
                                        <Text style={styles.tableCellsmallname}>{rowData.cname}</Text>
                                        <Text style={styles.tableCellmaxnew}>{parseFloat(rowData.mhliter || 0).toFixed(2)}</Text>
                                        <Text style={styles.tableCellmaxnew}>{parseFloat(rowData.gayliter || 0).toFixed(2)}</Text>
                                        <Text style={styles.tableCellmaxnew}>{parseFloat(rowData.tliter || 0).toFixed(2)}</Text>
                                        <Text style={styles.tableCellmaxnew}>{parseFloat(rowData.billamt || 0).toFixed(2)}</Text>
                                        <Text style={styles.tableCellmaxnew}>{totalDeduct}</Text>
                                        <Text style={styles.tableCellmaxnew}>{parseFloat(rowData.vah || 0).toFixed(2)}</Text>
                                        <Text style={styles.tableCellmaxnew}>
                                          {parseFloat(rowData.ada || 0).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)}
                                        </Text>
                                        <Text style={styles.tableCellmaxlast}>{""}</Text>
                                      </View>

                                      {/* Deduct row */}
                                      <View style={styles.tableRow}>
                                        <Text style={styles.kapatlable}>{t("pregisterprint5.deductRow.title")}</Text>

                                        <Text style={styles.tableCellmax2start}>
                                          {t("pregisterprint5.deductRow.deposit", { amt: rowData.cthev || 0 })}
                                        </Text>

                                        {parseFloat(rowData.cthevitr1 || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.dynamicNameAmt", {
                                              name: localStorage.getItem("itr1name"),
                                              amt: rowData.cthevitr1
                                            })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.cthevitr2 || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.dynamicNameAmt", {
                                              name: localStorage.getItem("itr2name"),
                                              amt: rowData.cthevitr2
                                            })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.cthevitr3 || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.dynamicNameAmt", {
                                              name: localStorage.getItem("itr3name"),
                                              amt: rowData.cthevitr3
                                            })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.advkapat || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.uchal", { amt: rowData.advkapat })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.khadyakapat || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.khady", { amt: rowData.khadyakapat })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.ratibkapat || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.ratib", { amt: rowData.ratibkapat })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.sanghkapat || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.sangh", { amt: rowData.sanghkapat })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.retan || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.retan", { amt: rowData.retan })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.medi || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.vet", { amt: rowData.medi })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.karjhpta || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.loan", { amt: rowData.karjhpta })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.karjintr || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.interest", { amt: rowData.karjintr })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.cbhishi || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.bhishi", { amt: rowData.cbhishi })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.ikapatbill || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.other", { amt: rowData.ikapatbill })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.itrkapat1 || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.dynamicNameAmt", {
                                              name: localStorage.getItem("itr4name"),
                                              amt: rowData.itrkapat1
                                            })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.itrkapat2 || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.dynamicNameAmt", {
                                              name: localStorage.getItem("itr5name"),
                                              amt: rowData.itrkapat2
                                            })}
                                          </Text>
                                        ) : null}

                                        {parseFloat(rowData.itrkapat3 || 0) > 0 ? (
                                          <Text style={styles.tableCellmax2}>
                                            {t("pregisterprint5.deductRow.dynamicNameAmt", {
                                              name: localStorage.getItem("itr6name"),
                                              amt: rowData.itrkapat3
                                            })}
                                          </Text>
                                        ) : null}

                                        <Text style={styles.tableCellmax2last}></Text>
                                      </View>
                                    </View>
                                  );
                                })}
                            </View>

                            {/* Payment Summary on last page */}
                            {pageIndex === totalPages5 - 1 && (
                              <View break>
                                <Text style={styles.latoText}>{safeText(customerData?.[0]?.kendra)}</Text>
                                <Text style={styles.latoText2}>{t("pregisterprint5.summary.title")}</Text>

                                <Text style={styles.latoText2}>
                                  {t("pregisterprint5.periodLine", {
                                    from: formatDate(localStorage.getItem("date1print")),
                                    to: formatDate(localStorage.getItem("date2print"))
                                  })}
                                </Text>

                                <View style={styles.tableRow2newsummery}>
                                  <Text style={styles.tableHeadersmallsummeryblank}>{""}</Text>
                                  <Text style={styles.tableHeadersmallsummery}>{t("pregisterprint5.summary.buffalo")}</Text>
                                  <Text style={styles.tableHeaderbiglastsummery}>{t("pregisterprint5.summary.cow")}</Text>
                                </View>

                                <View style={styles.tableRow2newsummery}>
                                  <Text style={styles.tableHeadersmallsummery}>{""}</Text>
                                  <Text style={styles.tableHeadersmallsummery}>{t("pregisterprint5.summary.morning")}</Text>
                                  <Text style={styles.tableHeadersmallsummery}>{t("pregisterprint5.summary.evening")}</Text>
                                  <Text style={styles.tableHeadersmallsummery}>{t("pregisterprint5.summary.total")}</Text>
                                  <Text style={styles.tableHeadersmallsummery}>{t("pregisterprint5.summary.morning")}</Text>
                                  <Text style={styles.tableHeadersmallsummery}>{t("pregisterprint5.summary.evening")}</Text>
                                  <Text style={styles.tableHeaderbiglastsummery}>{t("pregisterprint5.summary.total")}</Text>
                                </View>

                                <View style={styles.tableRow2whitesummery}>
                                  <Text style={styles.tableHeaderfirstsummery}>{t("pregisterprint5.summary.liter")}</Text>
                                  <Text style={styles.tableHeadersmallsummery}>{parseFloat(totals.mhmorliter || 0).toFixed(2)}</Text>
                                  <Text style={styles.tableHeadersmallsummery}>{parseFloat(totals.mhevnliter || 0).toFixed(2)}</Text>
                                  <Text style={styles.tableHeadersmallsummery}>{(parseFloat(totals.mhmorliter || 0) + parseFloat(totals.mhevnliter || 0)).toFixed(2)}</Text>
                                  <Text style={styles.tableHeadersmallsummery}>{parseFloat(totals.gaymorliter || 0).toFixed(2)}</Text>
                                  <Text style={styles.tableHeadersmallsummery}>{parseFloat(totals.gayevnliter || 0).toFixed(2)}</Text>
                                  <Text style={styles.tableHeaderbiglastsummery}>{(parseFloat(totals.gaymorliter || 0) + parseFloat(totals.gayevnliter || 0)).toFixed(2)}</Text>
                                </View>

                                <View style={styles.tableRow2whitesummery}>
                                  <Text style={styles.tableHeaderbigbottomsummery}>{t("pregisterprint5.summary.amount")}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummery}>{parseFloat(totals.mhmoramt || 0).toFixed(2)}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummery}>{parseFloat(totals.mhevnamt || 0).toFixed(2)}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummery}>{(parseFloat(totals.mhmoramt || 0) + parseFloat(totals.mhevnamt || 0)).toFixed(2)}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummery}>{parseFloat(totals.gaymoramt || 0).toFixed(2)}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummery}>{parseFloat(totals.gayevnamt || 0).toFixed(2)}</Text>
                                  <Text style={styles.tableHeaderbigbottomlastwhitesummery}>{(parseFloat(totals.gaymoramt || 0) + parseFloat(totals.gayevnamt || 0)).toFixed(2)}</Text>
                                </View>

                                {/* Deduct summary list */}
                                {[
                                  { key: "deposit", show: true, label: t("pregisterprint5.deductRow.depositLabel"), val: totals.cthev },
                                  { key: "itr1", show: parseFloat(totals.cthevitr1 || 0) > 0, label: localStorage.getItem("itr1name"), val: totals.cthevitr1 },
                                  { key: "itr2", show: parseFloat(totals.cthevitr2 || 0) > 0, label: localStorage.getItem("itr2name"), val: totals.cthevitr2 },
                                  { key: "itr3", show: parseFloat(totals.cthevitr3 || 0) > 0, label: localStorage.getItem("itr3name"), val: totals.cthevitr3 },
                                  { key: "uchal", show: parseFloat(totals.advkapat || 0) > 0, label: t("pregisterprint5.deductRow.uchalLabel"), val: totals.advkapat },
                                  { key: "khady", show: parseFloat(totals.khadyakapat || 0) > 0, label: t("pregisterprint5.deductRow.khadyLabel"), val: totals.khadyakapat },
                                  { key: "ratib", show: parseFloat(totals.ratibkapat || 0) > 0, label: t("pregisterprint5.deductRow.ratibLabel"), val: totals.ratibkapat },
                                  { key: "sangh", show: parseFloat(totals.sanghkapat || 0) > 0, label: t("pregisterprint5.deductRow.sanghLabel"), val: totals.sanghkapat },
                                  { key: "retan", show: parseFloat(totals.retan || 0) > 0, label: t("pregisterprint5.deductRow.retanLabel"), val: totals.retan },
                                  { key: "vet", show: parseFloat(totals.medi || 0) > 0, label: t("pregisterprint5.deductRow.vetLabel"), val: totals.medi },
                                  { key: "loan", show: parseFloat(totals.karjhpta || 0) > 0, label: t("pregisterprint5.deductRow.loanLabel"), val: totals.karjhpta },
                                  { key: "interest", show: parseFloat(totals.karjintr || 0) > 0, label: t("pregisterprint5.deductRow.interestLabel"), val: totals.karjintr },
                                  { key: "bhishi", show: parseFloat(totals.cbhishi || 0) > 0, label: t("pregisterprint5.deductRow.bhishiLabel"), val: totals.cbhishi },
                                  { key: "other", show: parseFloat(totals.ikapatbill || 0) > 0, label: t("pregisterprint5.deductRow.otherLabel"), val: totals.ikapatbill },
                                  { key: "itr4", show: parseFloat(totals.itrkapat1 || 0) > 0, label: localStorage.getItem("itr4name"), val: totals.itrkapat1 },
                                  { key: "itr5", show: parseFloat(totals.itrkapat2 || 0) > 0, label: localStorage.getItem("itr5name"), val: totals.itrkapat2 },
                                  { key: "itr6", show: parseFloat(totals.itrkapat3 || 0) > 0, label: localStorage.getItem("itr6name"), val: totals.itrkapat3 }
                                ].map((it) =>
                                  it.show ? (
                                    <View key={it.key} style={styles.tableRow2whitesummery}>
                                      <Text style={styles.tableHeaderbigbottomwhitesummerynoborderfirst}>{""}</Text>
                                      <Text style={styles.tableHeaderbigbottomwhitesummerynoborder}>{""}</Text>
                                      <Text style={styles.tableHeaderbigbottomwhitesummerynoborder}>{""}</Text>
                                      <Text style={styles.tableHeaderbigbottomwhitesummerynoborderrl}>{""}</Text>
                                      <Text style={styles.tableHeaderbigbottomwhitesummerynoborder}>{""}</Text>
                                      <Text style={styles.tableHeaderbigbottomwhitesummerynoborderslast}>{it.label}</Text>
                                      <Text style={styles.tableHeaderbigbottomwhitesummerynoborderlast}>{parseFloat(it.val || 0).toFixed(2)}</Text>
                                    </View>
                                  ) : null
                                )}

                                {/* Final totals rows */}
                                <View style={styles.tableRow2whitesummery}>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderlastrowfirst}>{""}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderlastrow}>{t("pregisterprint5.summary.cowPlusBuffalo")}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderlastrow}>{t("pregisterprint5.summary.totalMilk")}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderlastrl}>
                                    {(
                                      (parseFloat(totals.mhmorliter || 0) + parseFloat(totals.mhevnliter || 0)) +
                                      (parseFloat(totals.gaymorliter || 0) + parseFloat(totals.gayevnliter || 0))
                                    ).toFixed(2)}
                                  </Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderlastrow}>{""}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderslastrow}>{t("pregisterprint5.summary.totalDeduct")}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderslastrow2}>
                                    {parseFloat(
                                      parseFloat(totals.cthev || 0) +
                                      parseFloat(totals.cthevitr1 || 0) +
                                      parseFloat(totals.cthevitr2 || 0) +
                                      parseFloat(totals.cthevitr3 || 0) +
                                      parseFloat(totals.advkapat || 0) +
                                      parseFloat(totals.khadyakapat || 0) +
                                      parseFloat(totals.ratibkapat || 0) +
                                      parseFloat(totals.sanghkapat || 0) +
                                      parseFloat(totals.retan || 0) +
                                      parseFloat(totals.medi || 0) +
                                      parseFloat(totals.karjhpta || 0) +
                                      parseFloat(totals.karjintr || 0) +
                                      parseFloat(totals.cbhishi || 0) +
                                      parseFloat(totals.ikapatbill || 0) +
                                      parseFloat(totals.itrkapat1 || 0) +
                                      parseFloat(totals.itrkapat2 || 0) +
                                      parseFloat(totals.itrkapat3 || 0)
                                    ).toFixed(2)}
                                  </Text>
                                </View>

                                <View style={styles.tableRow2whitesummery}>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderlastrow2first}>{""}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderlastrow2}>{t("pregisterprint5.summary.cowPlusBuffalo")}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderlastrow2}>{t("pregisterprint5.summary.totalAmount")}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderlastrow2}>
                                    {(
                                      (parseFloat(totals.mhmoramt || 0) + parseFloat(totals.mhevnamt || 0)) +
                                      (parseFloat(totals.gaymoramt || 0) + parseFloat(totals.gayevnamt || 0))
                                    ).toFixed(2)}
                                  </Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderlastrow3}>{""}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderslastrow4}>{t("pregisterprint5.summary.netPayable")}</Text>
                                  <Text style={styles.tableHeaderbigbottomwhitesummerynoborderlastcell}>
                                    {parseFloat(totals.ada || 0).toFixed(2)}
                                  </Text>
                                </View>
                              </View>
                            )}
                          </Page>
                        ))
                      )}
                    </Document>
                  </PDFViewer>

                  : localStorage.getItem('pregister1') === "6" ?
                    <PDFViewer className='pdf'>
                      <Document>
                        {customerData.length > 0 && (
                          Array.from({ length: Math.ceil(customerData.length / recordsPerPage) }).map((_, pageIndex) => (
                            <Page
                              size="A4"
                              orientation="landscape"
                              style={{ marginTop: 20, marginLeft: 5, marginRight: 5 }}
                              key={pageIndex}
                            >
                              <Text style={styles.latoText}>{safeText(customerData?.[0]?.kendra)}</Text>

                              <Text style={styles.latoText2}>
                                {t("pregisterprint6.periodLine", {
                                  from: formatDate(localStorage.getItem("date1print")),
                                  to: formatDate(localStorage.getItem("date2print"))
                                })}
                              </Text>

                              <View style={styles.table}>
                                {/* Table Header */}
                                <View style={styles.tableRow2}>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.accountNo")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.name")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.buffaloLiter")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.cowLiter")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.totalLiter")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.totalBill")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.commission")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.transport")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.totalAmount")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.prevDeposit")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.onDeposit")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.totalDeposit")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.prevAdvanceBal")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.onAdvance")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.totalAdvance")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.advanceDeduct")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.newAdvanceBal")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.prevKhadyBal")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.onKhady")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.totalKhady")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.khadyDeduct")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.newKhadyBal")}</Text>
                                  <Text style={styles.tableHeader}>{t("pregisterprint6.table.otherDeduct")}</Text>
                                  <Text style={styles.tableHeaderlast}>{t("pregisterprint6.table.netPayable")}</Text>
                                </View>

                                {customerData
                                  .slice(pageIndex * recordsPerPage, (pageIndex + 1) * recordsPerPage)
                                  .map((rowData, index) => {
                                    const comm = parseFloat(rowData.comm) ? parseFloat(rowData.comm) : 0;
                                    const vah = parseFloat(rowData.vah) ? parseFloat(rowData.vah) : 0;
                                    const totalAmt = parseFloat(rowData.billamt || 0) + comm + vah;

                                    return (
                                      <View key={index} style={styles.tableRow}>
                                        <Text style={styles.tableCell}>{rowData.kno}</Text>
                                        <Text style={styles.tableCell}>{safeText(getFirstAndLastWord(rowData.cname))}</Text>

                                        <Text style={styles.tableCell}>{parseFloat(rowData.mhliter || 0).toFixed(1)}</Text>
                                        <Text style={styles.tableCell}>{parseFloat(rowData.gayliter || 0).toFixed(1)}</Text>
                                        <Text style={styles.tableCell}>{parseFloat(rowData.tliter || 0).toFixed(1)}</Text>

                                        <Text style={styles.tableCell}>{parseFloat(rowData.billamt || 0).toFixed(1)}</Text>

                                        <Text style={styles.tableCell}>{comm}</Text>
                                        <Text style={styles.tableCell}>{vah}</Text>

                                        <Text style={styles.tableCell}>{totalAmt}</Text>

                                        <Text style={styles.tableCell}>{parseFloat(rowData.magilthev || 0).toFixed(1)}</Text>
                                        <Text style={styles.tableCell}>{parseFloat(rowData.cthev || 0).toFixed(1)}</Text>
                                        <Text style={styles.tableCell}>{parseFloat(rowData.newthev || 0).toFixed(1)}</Text>

                                        <Text style={styles.tableCell}>{parseFloat(rowData.madv || 0).toFixed(1)}</Text>
                                        <Text style={styles.tableCell}>{parseFloat(rowData.cadv || 0).toFixed(1)}</Text>
                                        <Text style={styles.tableCell}>{parseFloat(rowData.tadv || 0).toFixed(1)}</Text>
                                        <Text style={styles.tableCell}>{parseFloat(rowData.advkapat || 0).toFixed(1)}</Text>
                                        <Text style={styles.tableCell}>{parseFloat(rowData.newadv || 0).toFixed(1)}</Text>

                                        <Text style={styles.tableCell}>{parseFloat(rowData.mkhadya || 0).toFixed(1)}</Text>
                                        <Text style={styles.tableCell}>{parseFloat(rowData.ckhadya || 0).toFixed(1)}</Text>
                                        <Text style={styles.tableCell}>{parseFloat(rowData.tkhadya || 0).toFixed(1)}</Text>
                                        <Text style={styles.tableCell}>{parseFloat(rowData.khadyakapat || 0).toFixed(1)}</Text>
                                        <Text style={styles.tableCell}>{parseFloat(rowData.newkhadya || 0).toFixed(1)}</Text>

                                        <Text style={styles.tableCell}>{parseFloat(rowData.ikapatbill) ? parseFloat(rowData.ikapatbill) : 0}</Text>

                                        <Text style={styles.tableCell}>
                                          {parseFloat(rowData.ada)
                                            ? parseFloat(rowData.ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)
                                            : 0}
                                        </Text>
                                      </View>
                                    );
                                  })}
                              </View>

                              {pageIndex === totalPages - 1 && (
                                <View style={styles.table}>
                                  <View style={styles.tableRow3}>
                                    <Text style={styles.tableHeader}>{t("pregisterprint6.totalRow.total")}</Text>
                                    <Text style={styles.tableHeader}>{t("pregisterprint6.totalRow.dash")}</Text>

                                    <Text style={styles.tableHeader}>{parseFloat(totals.tmhliter || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.tgayliter || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.tliter || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.billamt || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.tcomm || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.vah || 0).toFixed(0)}</Text>

                                    <Text style={styles.tableHeader}>{t("pregisterprint6.totalRow.dash")}</Text>

                                    <Text style={styles.tableHeader}>{parseFloat(totals.magilthev || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.cthev || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.newthev || 0).toFixed(0)}</Text>

                                    <Text style={styles.tableHeader}>{parseFloat(totals.madv || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.cadv || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.tadv || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.advkapat || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.newadv || 0).toFixed(0)}</Text>

                                    <Text style={styles.tableHeader}>{parseFloat(totals.mkhadya || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.ckhadya || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.tkhadya || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.khadyakapat || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeader}>{parseFloat(totals.newkhadya || 0).toFixed(0)}</Text>

                                    <Text style={styles.tableHeader}>{parseFloat(totals.ikapatbill || 0).toFixed(0)}</Text>
                                    <Text style={styles.tableHeaderlast}>
                                      {parseFloat(totals.ada || 0).toFixed(localStorage.getItem("round") === "on" ? 0 : 0)}
                                    </Text>
                                  </View>
                                </View>
                              )}
                            </Page>
                          ))
                        )}
                      </Document>
                    </PDFViewer>

                    : ''
      }
    </>
  );
};

// ... (styles and export)



const getStyles = (fontBase) =>
  StyleSheet.create({
    page: {

      flexDirection: 'row',
      justifyContent: 'center', // Center horizontally
      marginLeft: 13,
    },
    header: {
      position: 'absolute',
      top: 0, // Adjust this value to change the vertical position
      left: 0,
      right: 0,
      textAlign: 'center',
    },
    tableContainer: {
      display: 'flex',
      flexDirection: 'row',
      width: '95vw',
      justifyContent: 'space-between',
    },
    table: {
      display: 'table',
      width: '97%', // Adjust as needed to fit four tables in a row

    },
    tableone: {
      display: 'table',
      width: '18%', // Adjust as needed to fit four tables in a row

    },
    tableCellone: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      fontSize: 8,
      fontFamily: fontBase,
      textAlign: 'center',
      flex: 1, // Remove width and use flex to distribute space equally
    },
    tableRowone: {
      flexDirection: 'row',
      width: '100%',
    },
    tableHeaderone: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      border: '1px solid #000',
      padding: 2,
      fontSize: 8,
      textAlign: 'center',
      flex: 1, // Remove width and use flex to distribute space equally
    },

    tableRow: {
      flexDirection: 'row',

    },

    tableRowsub: {
      flexDirection: 'row',
      marginTop: 10
    },

    tableRow2new: {
      flexDirection: 'row',
      backgroundColor: 'lightgray',
      marginBottom: -10
    },

    tableRow2newsummery: {
      flexDirection: 'row',
      backgroundColor: 'lightgray',
      marginRight: 10
    },
    tableRow2whitesummery: {
      flexDirection: 'row',
      marginRight: 10
    },

    tableRow2: {
      flexDirection: 'row',
      backgroundColor: 'lightgray'
    },

    tableRow3: {
      flexDirection: 'row',
      backgroundColor: 'lightgray',
      marginTop: 10

    },
    line: {
      flexDirection: 'row',
      backgroundColor: 'lightgray',

      height: 1,
      width: '100vw',

    },

    tableHeadersmall: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.258,
      flexShrink: 0,
    },

    tableHeadersmallsummery: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeadersmallsummeryblank: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.184,
      flexShrink: 0,
    },


    tableHeaderfirstsummery: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      backgroundColor: 'lightgray',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeaderbiglastsummery: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeaderbigbottomsummery: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      backgroundColor: 'lightgray',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummery: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },
    tableHeaderbigbottomwhitesummerynoborder: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 0,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 0,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderfirst: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 0,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderslastrow: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 0,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderslastrow4: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 0,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderlastrow: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 0,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderlastrowfirst: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderlastrow3: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderlastrow2: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 0,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },


    tableHeaderbigbottomwhitesummerynoborderlastrow2first: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderslastrow2: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 0,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'right',
      paddingRight: 10,
      fontSize: 10,
      flexGrow: 0.493,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderlastcell: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 0,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'right',
      paddingRight: 10,
      fontSize: 10,
      flexGrow: 0.493,
      flexShrink: 0,
    },



    tableHeaderbigbottomwhitesummerynoborderrl: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 0,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.544,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderlastrl: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.544,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderlastrl2: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.544,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderslast: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 0,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.550,
      flexShrink: 0,
    },

    tableHeaderbigbottomwhitesummerynoborderlast: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 0,    // Add border only for top side
      borderBottomWidth: 0, // Add border only for bottom side
      borderLeftWidth: 0,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      paddingRight: 10,
      textAlign: 'right',
      fontSize: 10,
      flexGrow: 0.493,
      flexShrink: 0,
    },

    tableHeaderbigbottomlastwhitesummery: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
      flexGrow: 0.558,
      flexShrink: 0,
    },

    tableHeadersmallmed: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 9,
      flexGrow: 0.3,
      flexShrink: 0,
    },

    tableHeader: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 8,
    },
    tableHeaderbig: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderLeftWidth: 1,   // Add border only for left side
      borderBottomWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      paddingRight: 6,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
    },

    tableHeaderbigname: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderLeftWidth: 1,   // Add border only for left side
      borderBottomWidth: 0,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      flexGrow: 1.5,
      paddingRight: 6,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
    },

    tableHeaderbig5: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderLeftWidth: 1,   // Add border only for left side
      borderBottomWidth: 0,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      paddingRight: 6,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
    },
    tableHeaderbiglast: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      padding: 0.1,
      flex: 0.5,
      paddingRight: 6,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
    },

    tableHeaderlast: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      borderStyle: 'solid', // Set the border style to 'solid'
      borderColor: 'lightblack',
      padding: 2,
      flex: 0.5,
      textAlign: 'center',
      fontSize: 9,
    },
    tableHeadermax: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      padding: 0.1,
      flex: 0.4,
      borderColor: 'lightblack',
      textAlign: 'left',
      fontSize: 11,
      paddingLeft: 5,
      flexGrow: 1.1,
      flexShrink: 0,
    },

    tableCellsmall: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 10,
      fontFamily: fontBase,
      flexGrow: 0.4,
      flexShrink: 0,
      textAlign: 'center',
      height: 50,
      borderBottomColor: 'black'
    },

    tableCellsmall5: {
      borderLeftWidth: 1,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      padding: 0.5,
      flex: 1,
      fontSize: 10,
      fontFamily: fontBase,
      flexGrow: 0.95,
      flexShrink: 0,
      textAlign: 'center',
      paddingLeft: 5,
      height: 30,
    },


    tableCellsmallname: {
      borderLeftWidth: 1,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      padding: 0.5,
      flex: 1,
      fontSize: 10,
      fontFamily: fontBase,
      flexGrow: 7.18,
      flexShrink: 0,
      textAlign: 'center',
      paddingLeft: 5,
      height: 30,
    },
    tableCellsmall2: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 9,
      fontFamily: fontBase,
      flexGrow: 0.55,
      flexShrink: 0,
      textAlign: 'center',
      height: 20,
      borderBottomColor: 'black'
    },

    tableCellsmall2med: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 9,
      fontFamily: fontBase,
      flexGrow: 0.70,
      flexShrink: 0,
      textAlign: 'center',
      height: 20,
      borderBottomColor: 'black'
    },

    tableCellsmall2med2: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 9,
      fontFamily: fontBase,
      flexGrow: 0.8,
      flexShrink: 0,
      textAlign: 'center',
      height: 20,
      borderBottomColor: 'black'
    },

    tableCell: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 8,
      fontFamily: fontBase,
      width: 2,
      textAlign: 'center',
      height: 20,
      borderBottomColor: 'black'
    },

    tableCell2: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 9,
      fontFamily: fontBase,
      width: 2,
      textAlign: 'right',
      paddingRight: 5,
      height: 20,
      borderBottomColor: 'black'
    },

    tableCellbig: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 10,
      fontFamily: fontBase,
      width: 2,
      paddingLeft: 5,
      textAlign: 'center',
      paddingRight: 5,
      height: 50,
      borderBottomColor: 'black'
    },

    tableCellmax: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 10,
      fontFamily: fontBase,
      flexGrow: 2.40,
      flexShrink: 0,
      textAlign: 'center',
      paddingLeft: 5,
      borderBottomColor: 'black'
    },

    tableCellright: {
      borderStyle: 'solid',
      borderColor: 'lightgray',
      borderWidth: 0.5,       // overall border
      borderRightWidth: 0,    // override to remove right border
      padding: 2,
      padding: 0.5,
      flex: 1,
      fontSize: 10,
      fontFamily: fontBase,
      width: 2,
      paddingLeft: 5,
      textAlign: 'right',
      paddingRight: 5,
      height: 50,
      borderBottomColor: 'black'
    },

    tableCellmaxfirst: {
      borderLeftWidth: 1,
      borderBottomWidth: 1,
      padding: 0.5,
      flex: 1,
      fontSize: 11,
      fontFamily: fontBase,
      flexGrow: 2.43,
      flexShrink: 0,
      textAlign: 'center',
      paddingLeft: 5,
      height: 30,
    },


    tableCellmaxnew: {
      borderLeftWidth: 1,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      padding: 0.5,
      flex: 1,
      fontSize: 11,
      fontFamily: fontBase,
      flexGrow: 2.43,
      flexShrink: 0,
      textAlign: 'center',
      paddingLeft: 5,
      height: 30,
    },



    tableCellmaxlast: {
      borderLeftWidth: 1,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderRightWidth: 1,
      padding: 0.5,
      flex: 1,
      fontSize: 11,
      fontFamily: fontBase,
      flexGrow: 2.43,
      flexShrink: 0,
      textAlign: 'center',
      paddingLeft: 5,
      height: 30,
    },


    kapatlable: {
      borderLeftWidth: 1,
      borderBottomWidth: 1,
      padding: 0.5,
      paddingTop: 7,
      fontSize: 9,
      textAlign: 'center',
      width: 64,
      backgroundColor: 'whitesmoke',
      fontFamily: 'Lato-Italic'
    },

    tableCellmax2start: {
      borderLeftWidth: 1,
      borderBottomWidth: 1,
      padding: 0.5,
      fontSize: 9,
      textAlign: 'center',
      width: 50,
      fontFamily: 'Lato-Italic'
    },
    tableCellmax2: {
      borderBottomWidth: 1,
      padding: 0.5,
      fontSize: 9,
      textAlign: 'center',
      width: 50,
      fontFamily: 'Lato-Italic'
    },
    tableCellmax2last: {
      borderBottomWidth: 1,
      borderRightWidth: 1,
      padding: 0.5,
      fontSize: 9,
      textAlign: 'center',
      width: 1,
      fontFamily: 'Lato-Italic'
    },

    tableCellgreen: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 10,
      fontWeight: 'bold',
      fontFamily: fontBase,
      color: 'green',
      width: 2,
      textAlign: 'center',
    },
    tableCellred: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 9,
      fontWeight: 'bold',
      fontFamily: fontBase,
      color: 'red',
      width: 2,
      textAlign: 'center',
    },
    latoText: {
      fontFamily: fontBase,
      fontSize: 14,
      marginBottom: 2,
      textAlign: 'center',
      width: '100vw',
      fontWeight: 'bold',

    },
    latoText2: {
      fontFamily: fontBase,
      fontSize: 11,
      textAlign: 'center',
      width: '100vw',
      fontWeight: 'bold',
    },
    headtextsmall: {
      fontFamily: fontBase,
      fontSize: 10,
      fontWeight: 'bold',
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      width: '100vw',
    },
    row1: {
      display: 'flex',
      flexDirection: 'row',
      width: '100vw',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: 5,
      paddingRight: 5,
    },
    row2: {
      display: 'flex',
      flexDirection: 'row',
      width: '100vw',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: 140,
      paddingRight: 140,
      backgroundColor: 'lightgray',
    },
    column1: {
      display: 'flex',
      flexDirection: 'column',
      width: '19%',
      justifyContent: 'start',
      alignItems: 'flex-start', // Align text to the left
      paddingLeft: 5,
      paddingRight: 5,
      marginLeft: 20,
    },
    column2: {
      display: 'flex',
      flexDirection: 'column',
      width: '15%',
      justifyContent: 'start',
      alignItems: 'flex-start', // Align text to the left
      paddingLeft: 5,
      paddingRight: 5,


    },
    column3: {
      display: 'flex',
      flexDirection: 'column',
      width: '17%',
      justifyContent: 'start',
      alignItems: 'flex-start', // Align text to the left
      paddingLeft: 5,
      paddingRight: 5,

    },
    column1Row: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    column1Rowgray: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      padding: 6,
      marginTop: 5,
      border: '0.5px solid black',
      backgroundColor: 'lightgray'
    },
    column1Label: {
      fontFamily: fontBase,
      fontSize: 9,
      fontWeight: 'bold',
      textAlign: 'left', // Align labels to the left
    },
    column1Value: {
      fontFamily: fontBase,
      fontSize: 9,
      fontWeight: 'bold',
      textAlign: 'right', // Align values to the right
    },
    pageBreak: {
      pageBreakBefore: 'always',
    },
    totalsRow: {
      flexDirection: 'row',
      borderTop: '1px solid #000',
      paddingTop: 5,
      paddingLeft: 2,
    },
    totalsCell: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 8,
      width: 2,
      textAlign: 'center',
    },
    imagerow: {
      display: 'flex',
      flexDirection: 'row',
      width: '100vw',
      justifyContent: 'center',
      alignItems: 'center',
    },
    image: {
      width: 80, // Adjust the width as needed
      height: "auto", // Maintain aspect ratio
      marginLeft: -15,
      marginTop: 5

    },
    imgtext: {
      fontFamily: fontBase,
      fontSize: 9,
      fontWeight: 'bold',
      textAlign: 'center', // Align labels to the left
    },

    bottomrow: {
      display: 'flex',
      flexDirection: 'row',
      minHeight: 100,  // Ensures enough space for total rows
      height: 100,
      width: '100%',
      padding: 10,
      backgroundColor: 'lightgray',
      borderTop: '1px solid black',
    },
    box1: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginLeft: 10
    },
    box2: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: 10,
      width: '100%',

    },

    box3: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: 10,
      width: '100%',
    },

    box4: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: 10,
      width: '100%',
      marginRight: 10

    },

    bottomtitlerow: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      fontFamily: fontBase,
      fontWeight: 'bold',
      fontSize: 10,
      width: '70%',
      padding: 0.5,
      borderColor: 'lightblack',
      marginTop: 15,
      textAlign: 'start',

    },

    bottomtitlerow2: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      fontFamily: fontBase,
      fontWeight: 'bold',
      fontSize: 10,
      width: '100%',
      padding: 0.5,
      borderColor: 'lightblack',
      marginTop: 15,
      textAlign: 'start',
    },

    bottomtitlerow3: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      fontFamily: fontBase,
      fontWeight: 'bold',
      fontSize: 10,
      width: '85%',
      padding: 0.5,
      borderColor: 'lightblack',
      marginTop: 15,
      textAlign: 'start',
    },

    valueText: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      fontSize: 10,
    },

    valueTextbig: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      fontSize: 11,
    },
  });

export default Pregisterprint;
